module.exports = __webpack_public_path__ + "img/group.eac02962.png";